import * as React from 'react';
import s from '../../RequestCall.scss';
import { Trans } from 'react-i18next';
import { FormContext } from './FormContext';
import { FormSubmitButton } from './FormSubmitButton';
import { CancelButton, CancelButtonProps } from './CancelButton';

import { Text, Cell } from 'wix-style-react';
import { withInjectedRootStore, RootStore } from '../../../../providers';
import { Brands, Experiments } from '../../../../enums';
import classNames from 'classnames';
import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';

type ButtonsComponent = React.FC<any> & {
  Submit: React.FC;
  Cancel: React.FC<CancelButtonProps>;
};
interface ButtonsCompProps extends InjectedExperimentsProps {
  rootStore: RootStore;
}
const ButtonsComp: React.FC<ButtonsCompProps> = ({
  children,
  rootStore,
  experiments,
}) => {
  const { submitFailureMessage } = React.useContext(FormContext);
  const { brand } = rootStore.appStore.appContext;
  const isEnterpriseTab = experiments.enabled(Experiments.AddEnterpriseTab);
  return (
    <Cell span={12}>
      <div
        className={classNames(s.buttonsWrapper, {
          [s.enterpriseTab]: isEnterpriseTab,
        })}
      >
        <Text
          className={s.errorMessage}
          weight='normal'
          size='small'
          skin='error'
        >
          {submitFailureMessage && (
            <Trans i18nKey={submitFailureMessage}>
              placeholder
              <a
                target='_blank'
                href={`https://www.${
                  brand === Brands.EDITOR_X ? 'editorx' : 'wix'
                }.com/enterprise`}
              >
                Enterprise Page
              </a>
            </Trans>
          )}
        </Text>
        {children}
      </div>
    </Cell>
  );
};

export const Buttons: ButtonsComponent = withInjectedRootStore(
  withExperiments(ButtonsComp),
) as any;

Buttons.Submit = FormSubmitButton;
Buttons.Cancel = CancelButton;
